const englishStrings = require("../i18n/locales/en.json");

/**
 * Function to return the english string if string id is not found for the locale
 * @param intl
 * @param stringId
 * @param values optional placeholder values, e.g. {name: "Line 1"} for "Device {name}"
 * @return {*}
 */
export const getLocalizedMessage = ({intl, stringId, values}) => {
    return intl.formatMessage({
        id: stringId,
        defaultMessage: englishStrings[stringId]
    }, values)
};



// WEBPACK FOOTER //
// ./src/components/util/Localization.js